'use client'

import { useSession } from 'next-auth/react'
import Link from 'next/link'
import { useRouter } from 'next/navigation'
import { useEffect } from 'react'

import EmailStep from '@components/auth/email-step'
import Alert from '@components/ui/alert'
import AuthLayout from '@layouts/auth'
import { safeRedirectPath } from '@lib/safe-redirect'

const ALERTS: Record<string, string> = {
  invalid: 'That sign-in link is invalid or has expired. Request a new code below.',
  expired: 'Your session expired. Sign in again to continue.'
}

interface Props {
  redirect?: string
  alert?: string
  google?: string
}

const LoginView = ({ redirect: requestedRedirect, alert: alertKey, google }: Props) => {
  const router = useRouter()
  const { status } = useSession()
  const safeRedirect = safeRedirectPath(requestedRedirect)
  const redirect = safeRedirect === '/' ? undefined : safeRedirect
  const alert = alertKey ? ALERTS[alertKey] : undefined
  const googleEnabled = google !== '0' && Boolean(process.env.NEXT_PUBLIC_GOOGLE_LOGIN_ENABLED)

  useEffect(() => {
    if (status === 'authenticated') router.replace(redirect || '/')
  }, [status, router, redirect])

  return (
    <AuthLayout title="Sign in" heading="Sign in to OrbitID" subheading="We’ll email you a one-time code. No password needed.">
      {alert && (
        <Alert variant="warning" className="text-start">
          {alert}
        </Alert>
      )}
      <EmailStep googleEnabled={googleEnabled} redirect={redirect} cta="Continue with email" />
      <p className="pt-2 text-center text-[13.5px] text-o-muted">
        No account yet?{' '}
        <Link href="/signup" className="font-medium text-o-ink hover:underline">
          Create one
        </Link>
      </p>
    </AuthLayout>
  )
}

export default LoginView
